import { useCallback, useEffect, useState } from 'react'
import { doc, onSnapshot, Timestamp } from 'firebase/firestore'
import debounce from 'lodash/debounce'
import Fire from '../../firebaseConfig'

export const useCurrentUserUpdates = (uid, onUpdate) => {
  const [error, setError] = useState('')
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    setError('')
    if (!uid) return

    let previousTimestamp
    const refresh = debounce(onUpdate, 500)
    const unsubscribe = onSnapshot(
      doc(Fire.DB, 'userUpdates', uid),
      (snapshot) => {
        const updatedAt = snapshot.get('updatedAt')
        if (
          updatedAt instanceof Timestamp &&
          !previousTimestamp?.isEqual(updatedAt)
        ) {
          previousTimestamp = updatedAt
          refresh()
        }
      },
      () => setError('Live profile updates are unavailable.'),
    )
    return () => {
      unsubscribe()
      refresh.cancel()
    }
  }, [uid, onUpdate, attempt])

  const retry = useCallback(() => setAttempt((current) => current + 1), [])
  return { error, retry }
}
